/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SubClassResponseDto
 */
export interface SubClassResponseDto {
    /**
     * 
     * @type {number}
     * @memberof SubClassResponseDto
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof SubClassResponseDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof SubClassResponseDto
     */
    lineOfBusiness?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SubClassResponseDto
     */
    isActive: boolean;
}

/**
 * Check if a given object implements the SubClassResponseDto interface.
 */
export function instanceOfSubClassResponseDto(value: object): value is SubClassResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    return true;
}

export function SubClassResponseDtoFromJSON(json: any): SubClassResponseDto {
    return SubClassResponseDtoFromJSONTyped(json, false);
}

export function SubClassResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubClassResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'lineOfBusiness': json['lineOfBusiness'] == null ? undefined : json['lineOfBusiness'],
        'isActive': json['isActive'],
    };
}

export function SubClassResponseDtoToJSON(json: any): SubClassResponseDto {
    return SubClassResponseDtoToJSONTyped(json, false);
}

export function SubClassResponseDtoToJSONTyped(value?: SubClassResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'lineOfBusiness': value['lineOfBusiness'],
        'isActive': value['isActive'],
    };
}

